import { useState } from 'react'
import { colors } from '../../colors'
import { BargainUserInfo, Post, Theme } from '../../types'
import LoginModal from '../LoginModal'

interface ThemeCardProps {
  theme: Theme
  thumbnail_post: Post | undefined
  bargain_user_info: BargainUserInfo
}

// コンポーネントの外でスタイルを定義
const styles: Record<string, React.CSSProperties> = {
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: '100%',
    padding: '8px 14px',
    borderBottom: `1px solid ${colors['border-light']}`,
    backgroundColor: colors.white,
    minHeight: '87px',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: colors['keijiban-brown'],
    marginBottom: '0',
  },
  postStatus: {
    fontSize: '14px',
    fontWeight: 600,
    color: colors['keijiban-coral'],
  },
  actionButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors['primary'],
    borderRadius: '4px',
    padding: '6px 16px',
    color: 'white',
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  buttonText: {
    fontSize: '14px',
    fontWeight: 600,
  },
  buttonIcon: {
    fontSize: '12px',
  },
  arrowIcon: {
    fontSize: '18px',
    color: colors['keijiban-brown'],
  },
  themeImage: {
    width: '70px',
    height: '70px',
    borderRadius: '6px',
    objectFit: 'cover',
  },
}

const ThemeCard: React.FC<ThemeCardProps> = ({ theme, thumbnail_post, bargain_user_info }) => {
  const [showLoginModal, setShowLoginModal] = useState(false)

  const isPostable = () => {
    const now = new Date()
    const postStart = new Date(theme.entry_start_datetime)
    const postEnd = new Date(theme.entry_end_datetime)
    return now >= postStart && now <= postEnd
  }

  return (
    <div style={styles.card}>
      {isPostable() ? (
        <div style={styles.contentContainer}>
          <div style={styles.leftColumn}>
            <div style={styles.titleRow}>
              <h3 style={styles.title}>「{theme.title}」</h3>
            </div>
            <div>
              <span style={styles.postStatus}>
                {new Date(theme.entry_end_datetime).toLocaleDateString('ja-JP', {
                  month: 'numeric',
                  day: 'numeric',
                })}
                まで募集中
              </span>
            </div>
          </div>
          <div style={styles.rightColumn}>
            <a
              href={
                bargain_user_info.type !== 'guest'
                  ? `/webview/message_board/themes/${theme.id}/posts/new`
                  : undefined
              }
              style={{ textDecoration: 'none', cursor: 'pointer' }}
              onClick={
                bargain_user_info.type === 'guest'
                  ? (e) => {
                    e.preventDefault()
                    setShowLoginModal(true)
                  }
                  : undefined
              }
            >
              <div style={styles.actionButton}>
                <div style={styles.buttonContent}>
                  <span style={styles.buttonText}>参加する</span>
                  <span style={styles.buttonIcon} className="icon_font icf_post"></span>
                </div>
              </div>
            </a>
          </div>
        </div>
      ) : (
        <a
          href={`/webview/message_board/themes/${theme.id}/posts`}
          style={{ ...styles.contentContainer, textDecoration: 'none', cursor: 'pointer' }}
        >
          <div style={styles.leftColumn}>
            <div style={styles.titleRow}>
              <h3 style={styles.title}>「{theme.title}」</h3>
            </div>
          </div>
          <div style={styles.rightColumn}>
            {thumbnail_post?.images?.[0] && (
              <img
                src={thumbnail_post.images[0].image_url}
                alt={theme.title}
                style={styles.themeImage}
              />
            )}
            <span style={styles.arrowIcon} className="icon_font icf_arrow_right"></span>
          </div>
        </a>
      )}

      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
    </div>
  )
}

export default ThemeCard
